function changeSiblingColor(e) {
  const productId = e.target.closest('.product-block-options__item')?.dataset.productId;
  const productBlockList = e.target.closest('.product-block-list');
  const selectedProduct = productBlockList.querySelector(`.product-block.hidden-product[data-product-id="${productId}"]`);
  if(!selectedProduct) {
    return;
  }
  const currentProduct = e.target.closest(`product-block.current-product`);
  currentProduct?.classList.add('hidden-product')
  currentProduct?.classList.remove('current-product');
  selectedProduct?.classList.add('current-product');
  selectedProduct?.classList.remove('hidden-product');
}